module.exports = __webpack_public_path__ + "img/callcenter.17245836.png";